import { useDispatch } from 'react-redux';
import { Button } from '@mui/material';

import { Icon, showConfirmCancelDialog, useSettings, Utils } from 'app/main/components';
import { DetailsSectionWrapper } from 'app/main/components/page-layouts';

interface CommercialCampaignsDetailsSectionDeleteRowsProps {
	cmcpUid: string;
	table: string;
	isLoading: boolean;
	updateRefresh: VoidFunction;
}

export default function CommercialCampaignsDetailsSectionDeleteRows(
	props: CommercialCampaignsDetailsSectionDeleteRowsProps
) {
	const dispatch = useDispatch();
	const { t } = useSettings();

	const confirmSelection = () => {
		dispatch(
			showConfirmCancelDialog({
				title: t('DIALOG_EMPTY_LIST'),
				onConfirm: () =>
					Utils.executeStored({
						action: `st_commercialcampaigns_rows_delete`,
						dispatch,
						data: { cmrw_cmcp_uid: props.cmcpUid, table: props.table },
						successHandler: () => {
							dispatch(Utils.alertSuccessMsg(t));
							props.updateRefresh();
						}
					})
			})
		);
	};

	return (
		<DetailsSectionWrapper
			title={t('COMMERCIALCAMPAIGNS_SECTION_EMPTY_TITLE')}
			actions={
				<Button startIcon={<Icon icon="delete" />} onClick={confirmSelection} disabled={props.isLoading}>
					{t('COMMERCIALCAMPAIGNS_EMPTY_BUTTON_CLEAR')}
				</Button>
			}
		>
			{t('COMMERCIALCAMPAIGNS_SECTION_EMPTY_DESCRIPTION')}
		</DetailsSectionWrapper>
	);
}
